import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { SubmissionModal, CONTEXT } from '@fff-web/fff-ratings-and-reviews';

import env from '../../utils/env';
import ProductItem from './ProductItem/ProductItem';
import styles from './styles.module.scss';

const EMPTY_STATE = {
  productBrand: '',
  productName: '',
  imageUrl: '',
  productId: 0,
};

const setInitialRatings = (products) => products.reduce((result, product) => {
  return {
    ...result,
    [product.productId]: 0,
  };
}, {});
const getProduct = (products, productId) => products?.find((product) => product.productId === productId);

const ProductList = ({ products }) => {
  const [ratings, setRatings] = useState({});
  const [selectedProductId, setSelectedProductId] = useState(null);
  const [selectedValue, setSelectedValue] = useState(0);
  const selectedProduct = getProduct(products, selectedProductId) || EMPTY_STATE;

  const openModal = (productId, value) => {
    setSelectedProductId(productId);
    setSelectedValue(value);
  };
  const closeModal = () => setSelectedProductId(null);
  const handleOnSuccess = (response) => {
    const { productId, rating } = response.data.items[0];
    setRatings((prevState) => ({
      ...prevState,
      [productId]: rating,
    }))
  };
  useEffect(() => {
    if (products) {
      const initialRatings = setInitialRatings(products);
      setRatings(initialRatings);
    }
  }, [products]);

  return (
    <>
      <div className={styles.container} data-testid="rate-and-review-products">
        {products.map((product) => {
          const { imageUrl, productBrand, productId, productName } = product;
          const rating = ratings[productId] || 0;
          return (
            <ProductItem
              key={productId}
              productId={productId}
              imageUrl={imageUrl}
              productBrand={productBrand}
              productName={productName}
              rating={rating}
              onClick={openModal}
            />
          );
        })}
      </div>
      <SubmissionModal
        isOpen={!!selectedProductId}
        brandName={selectedProduct.productBrand}
        name={selectedProduct.productName}
        imgUrl={selectedProduct.imageUrl}
        productId={selectedProduct.productId}
        defaultRating={selectedValue}
        sku={selectedProduct.sku}
        context={CONTEXT.myReviews}
        env={env.appEnv}
        onSuccess={handleOnSuccess}
        closeModal={closeModal}
      />
    </>
  );
};

ProductList.propTypes = {
  products: PropTypes.arrayOf(PropTypes.shape()).isRequired,
}

export default ProductList;
